module.exports = __webpack_public_path__ + "static/img/6.f467d61.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/eng/6.png
// module id = hfei
// module chunks = 0